import { render, staticRenderFns } from "./PageBreakTitle.vue?vue&type=template&id=84948772&scoped=true&"
import script from "./PageBreakTitle.vue?vue&type=script&lang=js&"
export * from "./PageBreakTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84948772",
  null
  
)

export default component.exports